import * as React from "react";
import * as ReactDOM from "react-dom";
import {connect} from "react-redux";
import * as _ from "lodash";
import {IScreenComponentProps, screenComponent} from "../screenComponent";
import WorldCup from "./WorldCup";
import Intro from "./modals/intro/Intro";
import {MODALS} from "../../../store/reducers/modal";
import {hideModal, showModal} from "../../../store/actions/modals";
import ModalComponent from "../game/modals/ModalComponent";
import Outro from "./modals/outro/Outro";
import {resumeGame} from "../../../store/actions/game";
import BatteryIndicator from "./BatteryIndicator";
import {endYear} from '../../../store/actions/calendar/year';
import {recordEnergyGenerated} from '../../../store/actions/mini-game/energyGenerated';
import {showNextYearEndQuestion} from '../../../store/actions/questions/questions';
import {setScreen} from '../../../store/actions/screens';
import {SCREENS} from '../../../store/reducers/screen';
import YearEndQuestion from '../game/modals/event-question/YearEndQuestion';

interface MiniGameProps extends IScreenComponentProps
{
    showIntro: () => void;
    showOutro: () => void;
    showQuestion: () => void;
    resumeGame: () => void;
    endYear: () => void;
    recordEnergyGenerated: (energy: number) => void;
    showYearEndQuestion: () => void;
    closeModal: () => void;
}

export interface MiniGameState
{
    time_remaining: number;
    energy: number;
}

import './MiniGame.scss';

const game_time: number = 8;

const initial_state: MiniGameState =
    {
        time_remaining: game_time,
        energy: 0
    };


class MiniGame extends React.Component<MiniGameProps, MiniGameState>
{
    timer: number;
    energy_add: number = 5;
    energy_decay: number = 1;

    constructor(public props: MiniGameProps, public state: MiniGameState = initial_state)
    {
        super(props);
    }


    componentDidMount()
    {
    }


    componentDidUpdate(prev_props: MiniGameProps, prev_state: MiniGameState)
    {
        const {active} = this.props;

        if (! prev_props || prev_props.active === active) return;

        //  if the game is now active, let's prep the game and show the intro

        if (active) this.prepGame();
    }


    addListeners = () =>
    {
        document.addEventListener('keyup', this.onKeyUp);
    };


    removeListeners = () =>
    {
        document.removeEventListener('keyup', this.onKeyUp);
    };


    /**
     * when the user presses and releases the space bar, generate energy
     */
    onKeyUp = (event: KeyboardEvent) =>
    {
        if (event.keyCode !== 32) return;

        const {time_remaining} = this.state;

        if (! time_remaining) return;

        const energy: number = Math.min(this.state.energy + this.energy_add, 100);

        //  generate energy

        this.setState({energy});
    };


    /**
     * get the mini-game component
     * @returns {JSX.Element}
     */
    getMiniMiniGame = () : JSX.Element =>
    {
        const Component: React.ComponentClass<MiniGameState> = WorldCup;

        const {time_remaining, energy} = this.state;

        return <Component
                    time_remaining={Math.floor(time_remaining)}
                    energy={energy}/>
    };


    /**
     * prep the game
     */
    prepGame = () =>
    {
        this.setState({
            time_remaining: game_time,
            energy: 0
        });

        this.props.showIntro();
    };


    /**
     * start the game
     */
    startGame = () =>
    {
        this.timer = window.setInterval(this.onTick, 100);

        this.addListeners();
    };


    /**
     * stop the game
     */
    stopGame = () =>
    {
        if (this.timer) clearInterval(this.timer);

        this.removeListeners();

        this.props.showOutro();
    };


    /**
     * when the timer ticks, update the time and energy
     * @returns {any}
     */
    onTick = () =>
    {
        const {time_remaining, energy} = this.state;

        //  decrement the amount of time remaining

        const new_time_remaining: number = time_remaining - 0.1;

        //  have we run out of time? if so, stop the game

        if (new_time_remaining <= 0)
        {
            const {recordEnergyGenerated} = this.props;

            recordEnergyGenerated(energy);

            return this.stopGame();
        }

        //  if not,

        const new_energy: number = Math.max(energy - this.energy_decay, 0);

        this.setState({
            time_remaining: new_time_remaining,
            energy: new_energy
        });
    };


    onEndClick = () =>
    {
        const {showQuestion, closeModal} = this.props;

        // closeModal();

        _.delay(showQuestion, 500);
    };


    onQuestionCloseClick = () =>
    {
        // const {showQuestion, closeModal} = this.props;
        //
        // closeModal();
        //
        // // _.delay(showQuestion, 500);

        console.group('onQuestionCloseClick');
        console.log('closing', true);
        console.groupEnd();
    };


    render()
    {
        const {active, resumeGame, endYear} = this.props;
        const {time_remaining, energy} = this.state;

        if (! active) return null;

        const time_str: string = _.isFinite(time_remaining) ? time_remaining.toFixed(1) : null;

        return <div styleName={'mini-game'}>

            {this.getMiniMiniGame()}

            <div styleName={'timer'}>

                <i className="far fa-clock" />
                <p>{time_str} seconds</p>

            </div>

            <BatteryIndicator energy={energy}/>

            <div styleName={'instructions'}>

                <p>Hit the spacebar or screen as fast as you can!</p>

            </div>

            <ModalComponent
                subtype={'transparent'}
                modal_id={MODALS.MINI_GAME_INTRO}
                close_button_type={'none'}
                onClose={this.startGame}>

                <Intro startGame={this.startGame}/>

            </ModalComponent>

            <ModalComponent
                modal_id={MODALS.MINI_GAME_OUTRO}
                onClose={_.debounce(this.onEndClick, 500)}>

                <Outro energy={energy}/>

            </ModalComponent>

            <ModalComponent
                modal_id={MODALS.MINI_GAME_END_QUESTION}
                close_button_type={'none'}>

                <YearEndQuestion />

            </ModalComponent>

        </div>
    }
}


const mapStateToProps = state =>
{
    return {}
};


const mapDispatchToProps = dispatch =>
{
    return {
        showIntro: () => dispatch(showModal(MODALS.MINI_GAME_INTRO)),
        showOutro: () => dispatch(showModal(MODALS.MINI_GAME_OUTRO)),
        showQuestion: () => dispatch(showModal(MODALS.MINI_GAME_END_QUESTION)),
        resumeGame: () => dispatch(resumeGame()),
        endYear: () => dispatch(endYear()),
        recordEnergyGenerated: (energy: number) => dispatch(recordEnergyGenerated(energy)),
        closeModal: () => dispatch(setScreen(SCREENS.GAME)),
        showYearEndQuestion: () => dispatch(showNextYearEndQuestion()),
    }
};

export default screenComponent()(connect(mapStateToProps, mapDispatchToProps)(MiniGame));



// WEBPACK FOOTER //
// ./src/ts/app/screens/mini-game/MiniGame.tsx